// extracted by mini-css-extract-plugin
module.exports = {"module":"PageNotFound_module__tZBlF","inner":"PageNotFound_inner__2Hsv0","pretitle":"PageNotFound_pretitle__qfPtj"};